import React, { useEffect, useState } from "react";
import { fetchStock_profitloss } from "../../ApisService/apiService";
import styles from "../../../css/dashboard/fundamental/Profitloss.module.css";

const ProfitLoss = ({ selectedCompany }) => {
  const [PNLdata, setPNLData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (!selectedCompany || !selectedCompany.fincode) {
      setPNLData([]);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const profitloss = await fetchStock_profitloss(selectedCompany.fincode);
        setPNLData(profitloss.data || []);
      } catch (err) {
        setError("Failed to fetch data.");
      }
      setLoading(false);
    };

    fetchData();
  }, [selectedCompany]);

  const toggleRowVisibility = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!selectedCompany) {
    return <p className={styles.errorText}>No company selected.</p>;
  }

  const years = PNLdata.map((item) => item.Year_end);

  const financialData = [
    { type: "heading", label: "INCOME :" },
    { type: "data", label: "Gross Sales", key: "Total_gross_sales", expandable: true },
    { type: "subdata", label: "Sales", key: "Sales", parentKey: "Total_gross_sales" },
    { type: "subdata", label: "Job works", key: "Job_works", parentKey: "Total_gross_sales" },
    { type: "subdata", label: "Service income", key: "Service_income", parentKey: "Total_gross_sales" },
    { type: "subdata", label: "Revenue from property development", key: "Sales_property_development", parentKey: "Total_gross_sales" },
    // { type: "subdata", label: "Other Operational Income", key: "Total_gross_sales-Sales-Job_works-Service_income-Sales_property_development", parentKey: "Total_gross_sales" },
    { type: "subdata", label: "Other Operational Income", key: "other_operational_income", parentKey: "Total_gross_sales" },

    { type: "subdata", label: "Less: Excise Duty", key: "Excise", parentKey: "Total_gross_sales" },

    { type: "data", label: "Net Sales", key: "Net_sales" },

    { type: "heading", label: "EXPENDITURE :" },
    { type: "data", label: "Increase/Decrease in Stock", key: "Inc_Dec_Inventory" },
    { type: "data", label: "Raw Material Consumed", key: "Raw_matrs_consumed", expandable: true },
    { type: "subdata", label: "Opening Raw Materials", key: "Opening_RM", parentKey: "Raw_matrs_consumed" },
    { type: "subdata", label: "Purchases Raw Materials", key: "Purchases_RM", parentKey: "Raw_matrs_consumed" },
    { type: "subdata", label: "Closing Raw Materials", key: "Closing_RM", parentKey: "Raw_matrs_consumed" },
    { type: "subdata", label: "Other Direct Purchases", key: "Purchases_FG", parentKey: "Raw_matrs_consumed" },
    { type: "subdata", label: "Other raw material cost", key: "other_raw_material_cost", parentKey: "Raw_matrs_consumed" },
    // { type: "subdata", label: "Other raw material cost", key: "Raw_matrs_consumed-(Opening_RM+Purchases_RM-Closing_RM-Purchases_FG)", parentKey: "Raw_matrs_consumed" },



    { type: "data", label: "Power & Fuel Cost", key: "Power_Fuel", expandable: true },
    { type: "subdata", label: "Electricity & Power Materials", key: "Electricity", parentKey: "Power_Fuel" },
    { type: "subdata", label: "Oil, Fuel & Natural gas", key: "Oils_fuels", parentKey: "Power_Fuel" },
    { type: "subdata", label: "Coals etc", key: "Coals", parentKey: "Power_Fuel" },
    { type: "subdata", label: "Other power & fuel", key: "other_power_fuel", parentKey: "Power_Fuel" },

    // { type: "subdata", label: "Other power & fuel", key: "Power_Fuel-Electricity-Oils_fuels-Coals", parentKey: "Power_Fuel" },




    { type: "data", label: "Employee Cost", key: "Employees", expandable: true },
    { type: "subdata", label: "     Salaries, Wages & Bonus", key: "Salaries", parentKey: "Employees" },
    { type: "subdata", label: "     Contributions to EPF & Pension Funds", key: "Providend_fund_contri", parentKey: "Employees" },
    { type: "subdata", label: "     Workmen and Staff Welfare Expenses", key: "Staff_welfare", parentKey: "Employees" },
    { type: "subdata", label: "     Other Employees Cost", key: "Other_Employees_Cost", parentKey: "Employees" },

    // { type: "subdata", label: "Other Employees Cost", key: "Employees-Salaries-Providend_fund_contri-Staff_welfare", parentKey: "Employees" },


    { type: "data", label: "Other Manufacturing Expenses", key: "Other_Mfg_Exps", expandable: true },
    { type: "subdata", label: "       Sub-contracted / Out sourced services", key: "sub_contract", parentKey: "Other_Mfg_Exps" },
    { type: "subdata", label: "      Processing Charges", key: "processing_charges", parentKey: "Other_Mfg_Exps" },
    { type: "subdata", label: "     Repairs and Maintenance", key: "repairs_maintenance", parentKey: "Other_Mfg_Exps" },
    { type: "subdata", label: "     Packing Material Consumed", key: "Packing_materials", parentKey: "Other_Mfg_Exps" },
    { type: "subdata", label: "         Other Mfg Exp", key: "Other_Mfg_Exp", parentKey: "Other_Mfg_Exps" },
    // { type: "subdata", label: "         Other Mfg Exp", key: "Other_Mfg_Exps -  sub_contract -  processing_charges - repairs_maintenance - Packing_materials", parentKey: "Other_Mfg_Exps" },


    { type: "data", label: "General and Administration Expenses", key: "Sellg_Admn_Exps", expandable: true },
    { type: "subdata", label: "     Rent , Rates & Taxes", key: "rent_rates_taxes", parentKey: "Sellg_Admn_Exps" },
    { type: "subdata", label: "      Insurance", key: "Insurance", parentKey: "Sellg_Admn_Exps" },
    { type: "subdata", label: "     Printing and stationery", key: "priting_stationery", parentKey: "Sellg_Admn_Exps" },
    { type: "subdata", label: "         Professional and legal fees", key: "professional_charges", parentKey: "Sellg_Admn_Exps" },
    { type: "subdata", label: "      Traveling and conveyance", key: "travelling", parentKey: "Sellg_Admn_Exps" },
    { type: "subdata", label: "           Other Administration", key: "Other_Administration", parentKey: "Sellg_Admn_Exps" },
    // { type: "subdata", label: "           Other Administration", key: "Sellg_Admn_Exps-rent_rates_taxes-Insurance-priting_stationery-professional_charges-travelling", parentKey: "Sellg_Admn_Exps" },


    { type: "data", label: "Selling and Distribution Expenses", key: "Sellg_Exps", expandable: true },
    { type: "subdata", label: "     Advertisement & Sales Promotion", key: "Advertising", parentKey: "Sellg_Exps" },
    { type: "subdata", label: "           Sales Commissions & Incentives", key: "Commission_incentives", parentKey: "Sellg_Exps" },
    { type: "subdata", label: "        Freight and Forwarding", key: "freight_forwardings", parentKey: "Sellg_Exps" },
    { type: "subdata", label: "       Handling and Clearing Charges", key: "Handling_clearing", parentKey: "Sellg_Exps" },
    { type: "subdata", label: "         Other Selling Expenses", key: "Other_Selling_Expenses", parentKey: "Sellg_Exps" },
    // { type: "subdata", label: "         Other Selling Expenses", key: "Sellg_Exps-Advertising-Commission_incentives-freight_forwardings-Handling_clearing", parentKey: "Sellg_Exps" },



    { type: "data", label: "Miscellaneous Expenses", key: "Misc_exps", expandable: true },
    { type: "subdata", label: "      Bad debts /advances written off", key: "Bad_debts", parentKey: "Misc_exps" },
    { type: "subdata", label: "     Provision for doubtful debts", key: "Prov_Doubtfull_debts", parentKey: "Misc_exps" },
    { type: "subdata", label: "      Loss on disposal of fixed assets(net)", key: "Loss_Fixed_assets", parentKey: "Misc_exps" },
    { type: "subdata", label: "       Loss on foreign exchange fluctuations", key: "Loss_Foreign_exchange", parentKey: "Misc_exps" },
    { type: "subdata", label: "       Loss on sale of non-trade current investments", key: "Loss_sale_Investment", parentKey: "Misc_exps" },
    { type: "subdata", label: "     Other Miscellaneous Expenses", key: "Other_Miscellaneous_Expenses", parentKey: "Misc_exps" },
    // { type: "subdata", label: "     Other Miscellaneous Expenses", key: "Misc_exps-Bad_debts-Prov_Doubtfull_debts-Loss_Fixed_assets-Loss_Foreign_exchange-Loss_sale_Investment", parentKey: "Misc_exps" },
    
    { type: "data", label: "Total Expenditure", key: "Total_expendiure" },
    
    // { type: "data", label: "Operating Profit (Excl OI)", key: "Net_sales - Total_expendiure" },
    { type: "data", label: "Operating Profit (Excl OI)", key: "operating_profit_excl_OI" },
    
   
    
    
    { type: "data", label: "Other Income", key: "Other_income", expandable: true },
    { type: "subdata", label: "      Interest Received", key: "Interest_income", parentKey: "Other_income" },
    { type: "subdata", label: "     Dividend Received", key: "Dividend_income", parentKey: "Other_income" },
    { type: "subdata", label: "        Profit on sale of Fixed Assets", key: "Profit_FA", parentKey: "Other_income" },
    { type: "subdata", label: "      Profits on sale of Investments", key: "Profit_Investment", parentKey: "Other_income" },
    { type: "subdata", label: "      Provision Written Back", key: "Prov_written_back", parentKey: "Other_income" },
    { type: "subdata", label: "         Foreign Exchange Gains", key: "Foreign_exchange_gain", parentKey: "Other_income" },
    { type: "subdata", label: "       Others", key: "others_income_dividene", parentKey: "Other_income" },
    // { type: "subdata", label: "       Others", key: "Other_income - Interest_income - Dividend_income - Profit_FA - Profit_Investment - Prov_written_back - Foreign_exchange_gain", parentKey: "Other_income" }



    { type: "data", label: "Operating Profit", key: "Operating_profit"},
    { type: "data", label: "Interest", key: "Interest", expandable: true },
    { type: "subdata", label: "     InterestonDebenture / Bonds", key: "Interest_deb", parentKey: "Interest" },
    { type: "subdata", label: "     Interest on Term Loan", key: "Interest_Term_loans", parentKey: "Interest" },
    { type: "subdata", label: "       Intereston Fixed deposits", key: "Interest_fixed_deposits", parentKey: "Interest" },
    { type: "subdata", label: "      Bank Charges etc", key: "Bank_charges", parentKey: "Interest" },
    { type: "subdata", label: "      Other Interest", key: "Other_I_nterest", parentKey: "Interest" },
    // { type: "subdata", label: "      Other Interest", key: "Interest-Interest_deb-Interest_Term_loans-Interest_fixed_deposits-Bank_charges", parentKey: "Interest" },
    
    
    { type: "data", label: "PBDT", key: "Gross_profits"},
    { type: "data", label: "Depreciation", key: "Depreciation"},
    { type: "data", label: "Profit Before Taxation & Exceptional Items", key: "Profit_before_exception"},
    { type: "data", label: "Profit Before Tax", key: "Profit_before_tax" },
    
    { type: "data", label: "Provision for Tax", key: "Taxation", expandable: true },
    { type: "subdata", label: "     Current Income Tax", key: "Curr_tax", parentKey: "Taxation" },
    { type: "subdata", label: "      Deferred Tax", key: "Def_tax", parentKey: "Taxation" },
    { type: "subdata", label: "         Other taxes", key: "Taxation-Curr_tax_Def_tax", parentKey: "Taxation" },
    // { type: "subdata", label: "         Other taxes", key: "Taxation-Curr_tax-Def_tax", parentKey: "Taxation" },
    




    { type: "data", label: "Profit After Tax", key: "Profit_after_tax" },
    { type: "data", label: "Consolidated Net Profit", key: "Consolidated_NetProfit" },
    { type: "data", label: "Adjustments to PAT", key: "Adj_Net_profit" },
    { type: "data", label: "EProfit Balance B/F", key: "Profit_Brought_forward" },



    { type: "data", label: "Earnings Per Share (EPS)", key: "EPS" },
    { type: "data", label: "Adjusted EPS", key: "Adj_Eps" },
  ];


  const formatFincode = (fincode) => {
    const fincodeNumber = parseInt(fincode, 10);
    const year = Math.floor(fincodeNumber / 100);
    const month = fincodeNumber % 100;
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${year}-${monthNames[month - 1]}`;
  };
  const getSafeNumber = (val) => {
    if (val === undefined || val === null || val === "") return 0; // Fallback for empty values
    const cleaned = String(val).replace(/,/g, "").trim(); // Remove commas and whitespace
    const num = parseFloat(cleaned); // Try converting to float
    return isNaN(num) ? 0 : num; // If not a number, fallback to 0
  };



  return (
    <div className={styles.fundamentalcontainer}>
      <h2 className={styles.title}>
        Financial Data ({selectedCompany.fincode})
      </h2>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : PNLdata.length === 0 ? (
        <p className={styles.noDataText}>No data available.</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={`table-sm ${styles.table}`}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Metrics</th>
                {years.map((year, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {formatFincode(year)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {financialData.map((item, index) => {
                if (item.type === "heading") {
                  return (
                    <tr key={index} className={styles.sectionRow}>
                      <td colSpan={years.length + 1} className={styles.sectionHeader}>
                        {item.label}
                      </td>
                    </tr>
                  );
                }

                if (item.type === "data") {
                  return (
                    <React.Fragment key={index}>
                      <tr className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          {item.expandable ? (
                            <button
                              onClick={() => toggleRowVisibility(item.key)}
                              className={styles.toggleButton}
                            >
                              {expandedRows[item.key] ? "-" : "+"} {item.label}
                            </button>
                          ) : (
                            item.label
                          )}
                        </td>
                        {PNLdata.map((data, idx) => (
                          <td key={idx} className={styles.tableCell}>
                            {(item.key === "operating_profit_excl_OI") ? (
                              (() => {
                                const netSales = getSafeNumber(data?.Net_sales);
                                const totalExpenditure = getSafeNumber(data?.Total_expendiure);
                                const result = netSales - totalExpenditure;
                                return result.toFixed(2);
                              })()
                            ) : (
                              data[item.key] ?? "–"
                            )}
                          </td>
                        ))}

                      </tr>

                      {/* Show sub-rows when the expandable row is expanded */}
                      {expandedRows[item.key] &&
                        financialData
                          .filter((subItem) => subItem.type === "subdata" && subItem.parentKey === item.key)
                          .map((subItem, subIndex) => (
                            <tr key={`${index}-${subIndex}`} className={styles.subRow}>
                              <td className={styles.subRowCell}>
                                {subItem.label}
                              </td>
                              {PNLdata.map((data, idx) => (
                                <td key={idx} className={styles.subRowCell}>
                                  {(subItem.key === "other_operational_income" || subItem.key === "other_raw_material_cost" || subItem.key === "other_power_fuel" || subItem.key === "Other_Employees_Cost" || subItem.key === "Other_Mfg_Exp" || subItem.key === "Other_Administration" || subItem.key === "Other_Selling_Expenses" || subItem.key === "Other_Miscellaneous_Expenses" || subItem.key === "others_income_dividene" || subItem.key === "Other_I_nterest" || subItem.key === "Taxation-Curr_tax_Def_tax" ) ? (
                                    (() => {
                                      if (subItem.key === "other_operational_income") {
                                        const total = getSafeNumber(data?.Total_gross_sales);
                                        const sales = getSafeNumber(data?.Sales);
                                        const jobWorks = getSafeNumber(data?.Job_works);
                                        const serviceIncome = getSafeNumber(data?.Service_income);
                                        const propertyDev = getSafeNumber(data?.Sales_property_development);

                                        const result = total - sales - jobWorks - serviceIncome - propertyDev;
                                        return result.toFixed(2);
                                      }

                                      if (subItem.key === "other_raw_material_cost") {
                                        const totalRM = getSafeNumber(data?.Raw_matrs_consumed);
                                        const openingRM = getSafeNumber(data?.Opening_RM);
                                        const purchasesRM = getSafeNumber(data?.Purchases_RM);
                                        const closingRM = getSafeNumber(data?.Closing_RM);
                                        const purchasesFG = getSafeNumber(data?.Purchases_FG);

                                        const result = totalRM - (openingRM + purchasesRM - closingRM - purchasesFG);
                                        return result.toFixed(2);
                                      }

                                      if (subItem.key === "other_power_fuel") {
                                        const totalPF = getSafeNumber(data?.Power_Fuel);
                                        const electricity = getSafeNumber(data?.Electricity);
                                        const oilsFuels = getSafeNumber(data?.Oils_fuels);
                                        const coals = getSafeNumber(data?.Coals);

                                        const result = totalPF - electricity - oilsFuels - coals;
                                        return result.toFixed(2);
                                      }

                                      if (subItem.key === "Other_Employees_Cost") {
                                        const totalEmp = getSafeNumber(data?.Employees);
                                        const sal = getSafeNumber(data?.Salaries);
                                        const pf = getSafeNumber(data?.Providend_fund_contri);
                                        const welfare = getSafeNumber(data?.Staff_welfare);

                                        const result = totalEmp - sal - pf - welfare;
                                        return result.toFixed(2);
                                      }

                                      if (subItem.key.includes("Other_Mfg_Exp")) {
                                        const total = getSafeNumber(data?.Other_Mfg_Exps);
                                        const subContract = getSafeNumber(data?.sub_contract);
                                        const processing = getSafeNumber(data?.processing_charges);
                                        const repair = getSafeNumber(data?.repairs_maintenance);
                                        const pack = getSafeNumber(data?.Packing_materials);
                                        const result = total - subContract - processing - repair - pack;
                                        return result.toFixed(2);
                                      }

                                      if (subItem.key.includes("Other_Administration")) {
                                        const totalAdminExpenses = getSafeNumber(data?.Sellg_Admn_Exps);
                                        const rentTaxes = getSafeNumber(data?.rent_rates_taxes);
                                        const insurance = getSafeNumber(data?.Insurance);
                                        const printingStationery = getSafeNumber(data?.priting_stationery);
                                        const professionalCharges = getSafeNumber(data?.professional_charges);
                                        const travelling = getSafeNumber(data?.travelling);

                                        const otherAdminExpenses = totalAdminExpenses - rentTaxes - insurance - printingStationery - professionalCharges - travelling;
                                        return otherAdminExpenses.toFixed(2);
                                      }


                                      if (subItem.key.includes("Other_Selling_Expenses")) {
                                        const totalSellingExpenses = getSafeNumber(data?.Sellg_Exps);
                                        const advertisement = getSafeNumber(data?.Advertising);
                                        const commissions = getSafeNumber(data?.Commission_incentives);
                                        const freight = getSafeNumber(data?.freight_forwardings);
                                        const handling = getSafeNumber(data?.Handling_clearing);

                                        const otherSellingExpenses = totalSellingExpenses - advertisement - commissions - freight - handling;
                                        return otherSellingExpenses.toFixed(2);
                                      }

                                      if (subItem.key.includes("Other_Miscellaneous_Expenses")) {
                                        const totalMiscExpenses = getSafeNumber(data?.Misc_exps);
                                        const badDebts = getSafeNumber(data?.Bad_debts);
                                        const doubtfulDebts = getSafeNumber(data?.Prov_Doubtfull_debts);
                                        const lossFixedAssets = getSafeNumber(data?.Loss_Fixed_assets);
                                        const lossForex = getSafeNumber(data?.Loss_Foreign_exchange);
                                        const lossInvestments = getSafeNumber(data?.Loss_sale_Investment);

                                        const otherMiscExpenses = totalMiscExpenses - badDebts - doubtfulDebts - lossFixedAssets - lossForex - lossInvestments;
                                        return otherMiscExpenses.toFixed(2);
                                      }

                                      if (subItem.key.includes("others_income_dividene")) {
                                        const totalOtherIncome = getSafeNumber(data?.Other_income);
                                        const interestIncome = getSafeNumber(data?.Interest_income);
                                        const dividendIncome = getSafeNumber(data?.Dividend_income);
                                        const profitFA = getSafeNumber(data?.Profit_FA);
                                        const profitInvestment = getSafeNumber(data?.Profit_Investment);
                                        const provWrittenBack = getSafeNumber(data?.Prov_written_back);
                                        const forexGain = getSafeNumber(data?.Foreign_exchange_gain);
                                      
                                        const otherIncome =
                                          totalOtherIncome -
                                          interestIncome -
                                          dividendIncome -
                                          profitFA -
                                          profitInvestment -
                                          provWrittenBack -
                                          forexGain;
                                      
                                        return otherIncome.toFixed(2);
                                      }

                                      if (subItem.key.includes("Other_I_nterest")) {
                                        const totalInterest = getSafeNumber(data?.Interest);
                                        const interestDeb = getSafeNumber(data?.Interest_deb);
                                        const interestTerm = getSafeNumber(data?.Interest_Term_loans);
                                        const interestFD = getSafeNumber(data?.Interest_fixed_deposits);
                                        const bankCharges = getSafeNumber(data?.Bank_charges);
                                      
                                        const otherInterest = totalInterest - interestDeb - interestTerm - interestFD - bankCharges;
                                      
                                        return otherInterest.toFixed(2);
                                      }
                                      

                                      if (subItem.key.includes("Taxation-Curr_tax_Def_tax")) {
                                        const totalTax = getSafeNumber(data?.Taxation);
                                        const currentTax = getSafeNumber(data?.Curr_tax);
                                        const deferredTax = getSafeNumber(data?.Def_tax);
                                      
                                        const otherTaxes = totalTax - currentTax - deferredTax;
                                      
                                        return otherTaxes.toFixed(2);
                                      }
                                      
  






                                      return "–";
                                    })()
                                  ) : (
                                    data[subItem.key] ?? "–"
                                  )}



                                </td>
                              ))}
                            </tr>
                          ))}
                    </React.Fragment>
                  );
                }

                return null;
              })}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default ProfitLoss;
